// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1y06M","subheader":"ReorderModal_subheader__1m6dt","listWrap":"ReorderModal_listWrap__1cylL"};